module.exports = __webpack_public_path__ + "img/product3.09727bd6.jpg";